import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import UserSelect from './saved_job_components/UserSelect.react';
import CronScheduleInput from './saved_job_components/CronScheduleInput.react';
import { User } from '../../stores/UserStore';

const SavedJobSchedulingOptions = ({
  scheduledUserOptions, scheduledUser, updateScheduledUser, scheduleCron, updateScheduleCron }) => (
    <div className='detail'>
      <UserSelect
        scheduledUserOptions={scheduledUserOptions}
        scheduledUser={scheduledUser}
        updateScheduledUser={updateScheduledUser}
        label='Run As'
      />
      <CronScheduleInput
        scheduleCron={scheduleCron}
        updateScheduleCron={updateScheduleCron}
      />
    </div>
);

export default SavedJobSchedulingOptions;

SavedJobSchedulingOptions.propTypes = {
  scheduledUserOptions: ImmutablePropTypes.listOf(PropTypes.instanceOf(User)),
  scheduledUser: PropTypes.string,
  updateScheduledUser: PropTypes.func,
  scheduleCron: PropTypes.string,
  updateScheduleCron: PropTypes.func,
};
